export default __webpack_public_path__ + "static/media/MONITORAMENTO 24H.59fffb47.png";